import React from "react";
import "../styles/Explore.css";
import {
  FaBuildingColumns,
  FaPiggyBank,
  FaCreditCard,
  FaChartLine,
  FaChartPie,
  FaScroll,
} from "react-icons/fa6";

const services = [
  {
    icon: <FaBuildingColumns />,
    title: "Bank accounts",
    desc: "An offshore bank account lets you take care of day-to-day banking in major foreign currencies.",
    link: "#",
  },
  {
    icon: <FaPiggyBank />,
    title: "Savings accounts",
    desc: "Flexible, secure and simple savings in major foreign currencies.",
    link: "#",
  },
  {
    icon: <FaCreditCard />,
    title: "Personal loans",
    desc: "Access simple, conversion-free, major foreign currency international lending solutions on variable terms.",
    link: "#",
  },
  {
    icon: <FaChartLine />,
    title: "Investment solutions",
    desc: "Build an international investment portfolio of actively managed offshore investment solutions.",
    link: "#",
  },
  {
    icon: <FaChartPie />,
    title: "Structured products",
    desc: "Access uncomplicated, ready-made solutions and tap into the growth potential of expanding markets.",
    link: "#",
  },
  {
    icon: <FaScroll />,
    title: "Fiduciary services",
    desc: "Join our network of international clients who trust us to help grow, protect and pass on their wealth.",
    link: "#",
  },
];

export default function Explore() {
  return (
    <section className="explore">
      <h2 className="explore-heading">Explore our international banking services</h2>

      <div className="box-text">
        We offer our clients comprehensive investment solutions that are tailored to each particular client’s needs at a specific period of time.
        For 27 years, we have been providing secure and easy banking to over 400,000 who live, travel, shop and work in Malaysia and beyond.
        We make cross-border banking easy and secure.
      </div>

      <div className="explore-grid">
        {services.map((item, index) => (
          <div className="explore-card" key={index}>
            <div className="explore-icon">{item.icon}</div>
            <div className="explore-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <a href={item.link} className="explore-link">
                TELL ME MORE →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
